export enum Rates {
  Hertz = 'Hertz',
  Enterprise = 'Enterprise',
}
